import e6LogisticsMap from "@/components/e6LogisticsMap/src/main";

e6LogisticsMap.install = function (Vue) {
    Vue.component(e6LogisticsMap.name, e6LogisticsMap);
};
export default e6LogisticsMap;
